<template>
	<div>
        <Loading :value="loading" ></Loading>

          <!--  MODAL VALIDATION MISSION-->
            <v-dialog v-model="dialogDetail" transition="dialog-bottom-transition" scrollable :loading="loading" fullscreen hide-overlay>
                <v-card>
                    <v-toolbar card dark color="primary">
                        <v-toolbar-title>Fiche de Validation d'une mission {{detailMission.IdUtil}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click.native="closeDialog()">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout>
                            <v-flex>
                                <v-card color="" class="mb-5" flat >
                                    <v-layout wrap>
                                        <v-flex xs12 >
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Informations générales
                                            </v-alert>

                                            <v-card flat>

                                                <v-layout wrap>

                                                    <v-card-text>

                                                        <v-flex xs12>
                                                            <v-flex xs12 class="text-xs-left"> <!--HAUT-->
                                                                <v-layout row>
                                                                    <v-flex xs6 class="mr-4"> <!--COLONNE 1-->
                                                                        <v-layout row>
                                                                            <v-flex xs6>Date Depart</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{detailMission.debut}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Activite</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{detailMission.activite}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Date de la demande</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{detailMission.date}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Retour prevue</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{detailMission.dateEntrePrevue}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>



                                                                        <v-layout row>
                                                                            <v-flex xs6>Itineraire</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{detailMission.itineraire}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Marque</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{detailMission.marque}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Modele</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{detailMission.modele}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Serie</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{detailMission.serie}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>


                                                                        <v-layout row>
                                                                            <v-flex xs6>Moyen de transport</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{detailMission.modeTransport}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Date de paiement de la facture</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{detailMission.datePaiement}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>


                                                                    </v-flex>




                                                                    <v-flex xs6 > <!--COLONNE 2-->
                                                                        <v-layout row>
                                                                            <v-flex xs6>chantier</v-flex>
                                                                            <v-flex xs6 class="text-xs-right blue--text title">
                                                                                {{detailMission.chantier}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <!--<v-layout row>-->
                                                                            <!--<v-flex xs6>Budget Total validé  pour ce chantier</v-flex>-->
                                                                            <!--<v-flex xs6 class="text-xs-right blue&#45;&#45;text title">-->
                                                                                <!--{{new Intl.NumberFormat().format(detailMission.budgetTotalMission)  }}-->
                                                                            <!--</v-flex>-->
                                                                        <!--</v-layout>-->
                                                                        <!--<v-divider class="mb-3"></v-divider>-->

                                                                        <v-layout row>
                                                                            <v-flex xs6>Budget  validé  pour ce chantier</v-flex>
                                                                            <v-flex xs6 class="text-xs-right blue--text title">
                                                                                {{new Intl.NumberFormat().format(detailMission.budgetMoisMission)  }}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Montant total déjà decaissé</v-flex>
                                                                            <v-flex xs6 class="text-xs-right blue--text title">
                                                                                {{new Intl.NumberFormat().format(detailMission.mntMissionDecaisse)  }}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Montant restant à depenser</v-flex>
                                                                            <v-flex xs6 class="text-xs-right blue--text title">
                                                                                {{new Intl.NumberFormat().format(detailMission.ecart)  }}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Etat budget mission (si la facture est validée)</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                <el-tag
                                                                                        :type="(detailMission.ecart >= detailMission.totalFrais) ? 'success' : 'danger'"
                                                                                        disable-transitions>
                                                                                    <span v-if="detailMission.ecart >= detailMission.totalFrais">Dans le budget</span>
                                                                                    <span v-else>Hors budget</span>
                                                                                </el-tag>

                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Demandeur </v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{detailMission.demandeur}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Conducteur </v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{detailMission.nomPren}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Validateur 1 </v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{detailMission.validateur1}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Validateur 2 </v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{detailMission.validateur2}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>


                                                                        <v-layout row>
                                                                            <v-flex xs6>Etat</v-flex>
                                                                            <v-flex xs10 class="text-xs-right blue--text  title">
                                                                                {{detailMission.libEtat}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout wrap>
                                                                            <v-flex xs6>Description</v-flex>
                                                                            <v-flex xs12 class="text-xs-right title">
                                                                               <el-form class="demo-ruleForm">
                                                                                  <el-form-item   label="" style="width:100%" >
                                                                                      <el-input  :readonly="true"  type="textarea" v-model="detailMission.description"></el-input>
                                                                                  </el-form-item>
                                                                              </el-form >
                                                                            </v-flex>
                                                                        </v-layout>

                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-flex>
                                                        </v-flex>
                                                    </v-card-text>


                                                </v-layout>
                                            </v-card>

                                        </v-flex>

                                        <v-flex xs12>
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Informations participants
                                            </v-alert>
                                            <v-card color="" class="mb-5" >
                                                <v-card-text>
                                                    <v-layout wrap>

                                                        <v-flex xs12>
                                                            <el-table
                                                                    :data="detailMission.participants"
                                                                    style="width: 100%">
                                                                <el-table-column
                                                                        prop="nom"
                                                                        label="Nom"
                                                                        sortable
                                                                >
                                                                </el-table-column>
                                                                <el-table-column
                                                                        prop="prenom"
                                                                        label="Prenom"
                                                                >
                                                                </el-table-column>
                                                                <el-table-column
                                                                        prop="fonction"
                                                                        label="Fonction"
                                                                >
                                                                </el-table-column>
                                                            </el-table>
                                                        </v-flex>
                                                    </v-layout>

                                                </v-card-text>
                                            </v-card>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Informations frais de mission
                                            </v-alert>
                                            <v-card color="" class="mb-5" >
                                                <v-card-text>
                                                    <v-layout wrap>

                                                        <v-flex xs12>
                                                            <v-chip style="font-size:20px" label outline color="green"><b>Total (HT): {{new Intl.NumberFormat().format(detailMission.totalFraisHT)}}  fcfa</b></v-chip>
                                                            <v-chip style="font-size:20px" label outline color="green"><b>Total (TVA): {{new Intl.NumberFormat().format(detailMission.totalTva)}} fcfa</b></v-chip>
                                                            <v-chip style="font-size:20px" label outline color="green"><b>Total (TTC):{{new Intl.NumberFormat().format(detailMission.totalFrais)}} fcfa</b></v-chip>
                                                        </v-flex>

                                                        <v-flex xs12>
                                                            <el-table
                                                                    :data="detailMission.frais"
                                                                    style="width: 100%">
                                                                <el-table-column
                                                                        prop="libelle"
                                                                        label="Libelle"
                                                                        sortable
                                                                >
                                                                </el-table-column>
                                                                <el-table-column
                                                                        prop="quantite"
                                                                        label="Quantite"
                                                                >
                                                                </el-table-column>

                                                                <el-table-column
                                                                        prop="prixUnit"
                                                                        label="Prix unitaire"
                                                                >
                                                                  <template  slot-scope="scope">
                                                                        {{ new Intl.NumberFormat().format(scope.row.prixUnit)  }}
                                                                    </template>
                                                                </el-table-column>

                                                                <el-table-column
                                                                        prop="tva"
                                                                        label="TVA"
                                                                >
                                                                  <template  slot-scope="scope">
                                                                        {{ new Intl.NumberFormat().format(scope.row.tva)  }}
                                                                    </template>
                                                                </el-table-column>

                                                                <el-table-column
                                                                        prop="total"
                                                                        label="Total"
                                                                >
                                                                  <template  slot-scope="scope">
                                                                        {{ new Intl.NumberFormat().format(scope.row.total)  }}
                                                                    </template>
                                                                </el-table-column>
                                                            </el-table>
                                                        </v-flex>
                                                    </v-layout>

                                                </v-card-text>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card-text>

                    <div style="flex: 1 1 auto;"></div>



                </v-card>

                <v-tooltip top>
                    <v-btn v-if="detailMission.etat == 5" class="mb-5" style="margin-right: 100px"
                           absolute
                           slot="activator"
                           dark
                           fab
                           large
                           bottom
                           right
                           color="red"
                           @click="dialogConfirmRefus = true"
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                    <span>Refuser la mission</span>
                </v-tooltip>



                <v-tooltip top>
                    <v-btn v-if="detailMission.etat == 5" class="mb-5 ml-5"
                           absolute
                           slot="activator"
                           dark
                           fab
                           large
                           bottom
                           right
                           color="green"
                           @click="dialogConfirm = true"
                    >
                        <v-icon>done</v-icon>
                    </v-btn>
                    <span>Valider la mission</span>
                </v-tooltip>
            </v-dialog>
            <!-- FIN MODAL VALIDATION MISSION-->






         <!-- CONFIRMATION REFUS DEMANDE -->
         <v-layout row justify-center>
            <v-dialog v-model="dialogConfirmRefus" persistent max-width="650">
            <v-card>
                <v-card-title class="headline">Validation d'une demande de mission</v-card-title>
                <v-card-text>
                    <v-layout wrap>
                    <v-flex xs12 class="mb-2">
                     <el-alert
                        title="Voulez vous Refuser ce devis ?"
                        :closable="false"
                        show-icon
                        type="error">
                    </el-alert>
                </v-flex>
                <v-flex xs12>
                    <p class="grey--text font-weight-thin body-1">DEMANDE DE MISSION</p>
                    <p class="black--text .font-weight-regular subheading" >DMD-{{detailMission.IdUtil}}</p>
                </v-flex>
                <v-flex xs12>
                    <el-form  id="formRefus" :rules="ruleFormRefus" ref="refFormRefust"  label-position="top" :inline="true" :model="formRefus" class="demo-form-inline">
                     <v-flex xs12 >
                        <el-form-item style="width:100%" label="Commentaire" prop="rapportRefus" >
                            <el-input style="width:100%"  type="textarea" :rows="6" placeholder="Pourquoi voulez-vous refuser ?" v-model="formRefus.rapport"></el-input>
                        </el-form-item >
                    </v-flex>
                    </el-form>
                </v-flex>

            </v-layout>

                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" dark @click.native="dialogConfirmRefus = false">Annuler</v-btn>
                <v-btn color="red darken-1" dark @click.native="SubmitRefusDevis()">Refuser</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
         </v-layout>

         <!-- CONFIRMATION VALIDATION -->
        <v-layout row justify-center>
            <v-dialog v-model="dialogConfirm" persistent max-width="650">
            <v-card>
                <v-card-title class="headline">Validation d'une demande de mission</v-card-title>
                <v-card-text>
                    <v-layout wrap>
                    <v-flex xs12 class="mb-2">
                     <el-alert
                        title="Voulez vous valider le devis ?"
                        :closable="false"
                        show-icon
                        type="success">
                    </el-alert>
                </v-flex>
                <v-flex xs12>
                    <p class="grey--text font-weight-thin body-1">DEMANDE DE MISSION</p>
                    <p class="black--text .font-weight-regular subheading" >MISS-{{detailMission.IdUtil}}</p>
                </v-flex>
            </v-layout>

                    </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" dark @click.native="dialogConfirm = false">Annuler</v-btn>
                <v-btn color="green darken-1" dark  @click.native="SubmitValideDevis()">Confirmer</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
         </v-layout>
	</div>
</template>


<script>
    import Loading from '@/components/Loading'
    export default {
	components:{ Loading },
        name: "ModalValidationMiss",
        props:["show","detailMission"],
        data()
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            dialogDetail: false,
            dialogVisible: false,
            dialogConfirmRefus: false,
            dialogConfirm: false,
            formRefus:{},
             ruleFormRefus: {
                rapportRefus: [
                    { required: true, message: 'Veuillez saisir' },
                ],
            }
         }
        },

        computed:{

        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogDetail = newValue
               if(newValue == true){
                   //this.loadDevisConstat()
               }
            }
        },

        methods: {
             successNotif(mess = ""){
                this.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: mess,
                        type: 'success',
                        position: 'top-center'
                })
            },
            SubmitValideBudget(){

            },
             closeDialog(){
                this.$emit('close',this.detailMission.IdUtil,"mission")
            },

             SubmitValideDevis(){
               this.loading = true;
                let url = this.domaine + "mission/valide/mission";
                let data = new FormData()
                data.append("idMission", this.detailMission.IdUtil)
                data.append("etatValMiss", this.detailMission.etat)
                data.append("idVeh", this.detailMission.idVeh)
                data.append("user", this.user.id);

                this.$http.post(url,data).then(response => {
                this.loading = false
                this.successNotif(response.body.message)
                 this.dialogConfirm = false
                  this.closeDialog();


            },errResp=>{
                 this.loading = false
                 this.$message.error("Une erreur est survenue lors de la validation de la mission")
            })
            },
             SubmitRefusDevis(){
                this.loading = true;
                let url = this.domaine + "mission/rejeter";
                var data = new FormData()
                data.append("motifRefus", this.formRefus.rapport)
                data.append("idMission", this.detailMission.IdUtil)
                data.append("user", this.user.id);

                this.$http.post(url,data).then(response => {
                this.loading = false
                this.successNotif(response.body.message)
                 this.dialogConfirmRefus = false
                this.closeDialog();

            },errResp=>{
                 this.loading = false
                 this.$message.error("Une erreur est survenue lors du refus de la demande de mission")
            })
            }
        },
        mounted(){

        }

    }
    </script>



// WEBPACK FOOTER //
// src/components/validationDG/ModalValidationMiss.vue